import React, { Component } from 'react';
import { ListGroup, Card } from 'react-bootstrap';

export class SundaySchedule extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      isLoaded: false,
      schedule: []
    };
  }

  componentDidMount() {
    fetch("/data/sundayschedule.json")
      .then(res => res.json())
      .then(
        (result) => {
        this.setState({
          isLoaded: true,
          schedule: result
        });
      })
      .catch(() => {this.setState({isLoaded: true})});
    }

  render() {
    const {isLoaded, schedule } = this.state;
  if (!isLoaded) {
    return <div>Loading...</div>;
  } else {
    if (schedule.length === 0) {
      return <div>No schedule found</div>;
    } else {
      return <div>
        <h3>{schedule.Title}</h3>
        {schedule.Meetings.map(meeting => (
          <Card>
            <Card.Body>
              <Card.Title>
                {meeting.Title}
              </Card.Title>
                {meeting.Groups.map(group => (
                  <ListGroup>
                    {group.Items.map((item, index) => {
                      if (index === 0)
                      {
                          return <ListGroup.Item><b>{item}</b></ListGroup.Item>
                      }
                      return <ListGroup.Item>{item}</ListGroup.Item>
                    })}
                  </ListGroup> 
                ))}
              </Card.Body>              
            </Card>
        ))}
      </div>;
      }
    }
  }
}

  
